

import settings from '../engines/old/beam-engine/settings';
import GLScene from '../engines/old/GLScene';
import  GLSceneBridge from  '../engines/GLSceneBridge';

import cookies from '../utils/cookies';
import support from '../utils/support';
import tween from '../utils/Tween';

import Slideshow from './Slideshow';
import SplitText from './SplitText';

// App decide which profile to sue based on framerate
// Then the actual settings are delegated to the engine
let hasForcedSDOnce = false;
let hasForcedHDOnce = false;
let lastDate;
let hasAverageFPS = false;
let averageFPS = 0;
let numAvaerageFrames = 100000;


const NUM_SCROLL_VH = 4;

export default class WebApplication extends HTMLElement {

    constructor() {
        super();
        
        this.el = this;

        this.onModalClose       = this.onModalClose.bind(this);
        this.onJsLinkDown       = this.onJsLinkDown.bind(this);
        this.toggleMenu         = this.toggleMenu.bind(this);
        this.onAudioDown        = this.onAudioDown.bind(this);
        this.onGPTButtonDown    = this.onGPTButtonDown.bind(this);
        this.onPlayBtnDown      = this.onPlayBtnDown.bind(this);
        this.onKeyDown          = this.onKeyDown.bind(this);
        this.onKeyUp            = this.onKeyUp.bind(this);
        this.onGPTRoomBtnDown   = this.onGPTRoomBtnDown.bind(this);
        this.resize             = this.resize.bind(this);
        this.onUIHover          = this.onUIHover.bind(this);
        this.onUILeave          = this.onUILeave.bind(this);
        this.onModaleButtonDown = this.onModaleButtonDown.bind(this);
        this.onStartButtonDown  = this.onStartButtonDown.bind(this);
        this.onPopState         = this.onPopState.bind(this);

        this._scrollTop           = 0;
        this.scrollProgress       = 0;
        this.easedScrollProgress  = 0;
        this.cameraVelocity       = 0;
        this.cameraVelocityBack   = 0;
        this.cameraVelocityLeft   = 0;
        this.cameraVelocityRight  = 0;
        this.cameraRotationY      = 0;


        this._prevCameraProgress = 0;
this._prevScrollProgress = 0;
    }

    disconnectedCallback() {
        window.removeEventListener('popstate', this.onPopState);
    }

    connectedCallback() {


        // Seed the current entry so state.url exists
        const currentUrl = this.normalizeInternalUrl(
            window.location.pathname + window.location.search + window.location.hash
        );
        window.history.replaceState({ url: currentUrl }, '', currentUrl);
        window.addEventListener('popstate', this.onPopState);


        const $uhfHeader = document.querySelector('#page-header uhf-header');
        if ($uhfHeader) {
            $uhfHeader.setAttribute('aria-hidden', true);
            $uhfHeader.setAttribute('tabindex', -1);
            $uhfHeader.querySelectorAll('a, button, input, [role="button"]').forEach(el => el.setAttribute('tabindex', -1) );
        }
        
        const $uhfFooter = document.querySelector('#footerArea');
        if ($uhfFooter) {
            $uhfFooter.setAttribute('aria-hidden', true);
            $uhfFooter.setAttribute('tabindex', -1);
            $uhfFooter.querySelectorAll('a, button, input, [role="button"]').forEach(el => el.setAttribute('tabindex', -1) );
        }

        const $skipBtn = document.querySelector('#uhfSkipToMain');
        if ($skipBtn) {
            $skipBtn.setAttribute('tabindex', -1);
            $skipBtn.setAttribute('aria-hidden', true);
            $skipBtn.querySelectorAll('a, button, input, [role="button"]').forEach(el => el.setAttribute('tabindex', -1) );
        }

        this.useScroll = /*!support.touch && */this.el.getAttribute('data-scroll') == 'true'


        this.numScrollVH =  this.el.hasAttribute('data-num-scroll-vh') &&  Number(this.el.getAttribute('data-num-scroll-vh')) > 0 ? Number(this.el.getAttribute('data-num-scroll-vh')) : NUM_SCROLL_VH;
        

        if (!this.$glScene) {
            const $glSceneWrapper = this.querySelector('[gl-scene]');
            let glHandler;
            this.isOldEngine;
            if ($glSceneWrapper) {
                glHandler = new GLScene($glSceneWrapper);
                this.isOldEngine = true;
            }
            else {
                glHandler = this.querySelector('page-experience');
                this.isOldEngine = false;
            }
            this.glSceneBridge = new GLSceneBridge(glHandler, this.isOldEngine);
        }    

        this.$pageContainer = this.querySelector('[data-page-container]');
        this.$modale        = this.querySelector('[data-modale]');
        this.$bottomRightNav = this.querySelector('[bottom-right-nav]');

        if (this.useScroll) {
            this.$fakeScrollHeight = document.createElement('div');
            this.appendChild(this.$fakeScrollHeight)
            window.addEventListener('scroll', ()=>{
                let py = window.pageYOffset|| document.documentElement.scrollTop;
                this._scrollTop = py 
                this._scrollTop = Math.max(0, this._scrollTop)
            });
        }

        if (!support.touch) {
            this.cursor         = {x:0,y:0}
            this.smoothedCursor = {x:0,y:0}
            this.cursors        = []
            this.$cursors = document.querySelectorAll('[data-cursor]')
            this.$cursors.forEach((el, i)=>{
                let cursor = {
                    ratio: Number(el.getAttribute('data-ratio')),
                    layers: []
                }
                el.querySelectorAll('[data-cursor-layer]').forEach((layerNode)=>{
                    cursor.layers.push({ el: layerNode, x: 0, y: 0 })
                });
                this.cursors.push(cursor)
            })
            document.addEventListener(support.pointermove, (e)=>{
                e = support.touch ? (e.touches[0] || e.changedTouches[0]) : e;
                this.cursor.x = e.pageX;
                this.cursor.y = e.pageY - (window.pageYOffset || document.documentElement.scrollTop);
            });
        }

        this.$modeButtons = document.querySelectorAll('[data-mode-button]')
        this.$modeButtons?.forEach((el)=>{
            el.addEventListener('click', (e)=>{
                let mode =  el.getAttribute('data-mode');
                this.setProfile(mode);
            });
        });


        this.$scrollButton = document.querySelectorAll('[data-scroll-button]')
        this.$scrollButton?.forEach((el)=>{
            el.addEventListener('click', (e)=>{
                let scrollVH = Number(el.getAttribute('data-scroll-vh'));
                const opt = {_scrollTop: this._scrollTop};
                const targetScroll = window.innerHeight * (scrollVH - 1);
                const distanceVH = Math.abs(targetScroll - this._scrollTop) / window.innerHeight;
                this.cameraVelocityLeft = 0;
                this.cameraVelocityRight = 0;
                if (distanceVH > 2) {
                    this._scrollTop = targetScroll;
                    this.scrollProgress = targetScroll / (window.innerHeight * (this.numScrollVH - 1));
                    this.easedScrollProgress = this.scrollProgress;
                    this.glSceneBridge.resetCameraPathRotation();
                    window.scrollTo(0, targetScroll);
                }
                else {
                    const duration =   distanceVH * 3;
                    tween(opt, {
                        to: {_scrollTop: targetScroll},
                        duration: duration,
                        easing: [0.430, 0.195, 0.305, 1.000],
                        step: (e)=>{
                            window.scrollTo(0, opt._scrollTop);
                        }
                    });
                }
            });
        });
         
                   

        document.addEventListener("keydown", this.onKeyDown, false);
        document.addEventListener("keyup", this.onKeyUp, false);

        window.addEventListener("resize", this.resize, false);
        window.addEventListener("orientationchange", this.resize, false);

        this.update();

        this.initPage();
    }

    resize() {
        this.glSceneBridge?.resize();
    }

    toggleMenu() {
        this.isMenuOpened = !this.isMenuOpened
        document.body.classList[this.isMenuOpened?'add':'remove']('is-menu-opened')
    }
    
    openModale(title, text, type, slides, youtubeId, audioTrack) {

        if (type == "youtube" && window.innerWidth < 768) {
            window.open('https://www.youtube.com/watch?v=' + youtubeId);
            return
        }

        this.isModaleOpened = true;
        this.modaleType = type;

        if (type == 'mesh') {
            this.glSceneBridge.focusObject(0)
            document.body.classList.add('is-mesh-modale')
        }

        this.$modaleSlideshowContent.innerHTML = '';
        let slideshowcontent = '';
        if (slides) {
            slides = JSON.parse(slides);
            console.log('OPEN_MODAL: SLIDESHOW', slides);
            slides.forEach((slide,i)=>{
                slideshowcontent += this.modaleSlideshowSlide
                    .replace('{{title}}',slide.title)
                    .replace('{{left}}',window.innerWidth < 768 ? (i*100) : 0 )
                    .replace('{{text}}',slide.text)
                    .replace('{{img}}',slide.img ? '<img src="'+slide.img.url+'"/>':'')
            })
        }
        this.$modaleSlideshowContent.innerHTML = slideshowcontent
        this.$modaleSlideshowContent.style.display = 'block'
        
        if (type == "youtube") {
            this.$modaleYoutube.style.display = 'block'
            this.$modaleIframe.src = '//www.youtube-nocookie.com/embed/' + youtubeId + '?loop=1&rel=0&fs=0&showinfo=0&modestbranding=1'
            this.$modaleSlideshow.style.display = 'none'
        }
        else if (type=="slideshow" || type=="mesh") {
            this.$modaleYoutube.style.display = 'none'
            this.$modaleIframe.removeAttribute('src');
            this.$modaleSlideshow.style.display = 'block'
            this.$modaleSlideshow.slideshow && this.$modaleSlideshow.slideshow.destroy()
            this.$modaleSlideshow.slideshow = new Slideshow( this.$modaleSlideshow, {
                onChange:(index)=>{
                    type == "mesh" && this.glSceneBridge.focusObject(index)
                }
            } )
        }
        document.body.classList.add('is-modale-opened')
    }

    closeModale() {
        document.body.classList.remove('is-mesh-modale')
        this.isModaleOpened = false
        document.body.classList.remove('is-modale-opened')
        this.$modaleIframe.removeAttribute('src');
        this.glSceneBridge.unfocusObject()
    }

    async initPage() {

        let $pageContainer = this.querySelector('[data-page-container]');

        // GPT chat 
        if (document.defaultView && document.defaultView.CustomEvent) {
            const roomChannel = $pageContainer.getAttribute('data-room-channel');
            const myMessageEvent = new document.defaultView.CustomEvent('room-channel', { detail: roomChannel });
            document.dispatchEvent(myMessageEvent);
        }

        // back to azure general site
        this.$backLink = document.querySelector('[data-backlink]')
        const urlParams = new URLSearchParams(window.location.search);
        const ref       = urlParams.get('ref');
        if (ref === 'azure-global-infrastructure-experience') {
            // this.$backLink && this.$backLink.setAttribute('href', target)
            this.$backLink?.setAttribute('href', "https://datacenters.microsoft.com/globe/explore");
            this.$backLink?.setAttribute('fixed-href', true);
            this.$backLink.style.display = 'inline-block';
        }

        //start the tour button
        this.isIntroPage = $pageContainer.getAttribute('data-is-home') === 'true';

        document.body.classList[ this.isIntroPage  ? 'add':'remove']('is-intro');

        this.$introBtn = this.$pageContainer.querySelector('[data-intro-btn]');
        this.$introBtn?.addEventListener('click', ()=>{
            document.body.classList.add('has-started');
            this.autoScrollProgress = this.autoScrollProgress || 0
            tween(this, {
                to: {autoScrollProgress: 1},
                duration: 4,
                easing: [ 0.430, 0.195, 0.305, 1.000],
                step: (e)=>{
                    if (this.useScroll) {
                        window.scrollTo( 0, this.autoScrollProgress * (window.innerHeight * (this.numScrollVH - 1)) );
                        // this.hasStarted = true;
                    }
                    else {
                        this.glSceneBridge.setCameraProgress(this.autoScrollProgress)
                        if (this.autoScrollProgress > 0.3) {
                            document.body.classList.add('has-started')
                            document.body.classList.add('has-played-intro')
                            this.glSceneBridge.setHomeDrag(true);
                            // this.hasStarted = true;
                        }
                    }
                },
            });
        });
        
        this.isAudioOpened = false;
        this.$audiobutton = this.querySelectorAll('[data-audio-button]')
        this.$audiobutton.forEach((el)=>{
            el.removeEventListener('click', this.onAudioDown);
            el.addEventListener('click',  this.onAudioDown, false);
        });


        this.isGPTOpened = false;
        this.$gptbutton = this.querySelectorAll('[data-gpt-button]')
        this.$gptbutton.forEach((el)=>{
            el.removeEventListener('click', this.onGPTButtonDown);
            el.addEventListener('click',  this.onGPTButtonDown, false);
        });
        

        this.playingaudio = false;
        this.$audioPlay = document.querySelector('[data-audio-play]')
        this.$audioTag = document.querySelector('[data-audio-tag]')
        
        this.$audioPlayIcon = document.querySelector('[data-audio-playicon]')
        this.$audioPauseIcon = document.querySelector('[data-audio-pauseicon]')
        
        this.$audioPlay && this.$audioPlay.removeEventListener('click', this.onPlayBtnDown, false)
        this.$audioPlay && this.$audioPlay.addEventListener('click',this.onPlayBtnDown, false)

        this.$uiElements = this.$pageContainer.querySelectorAll('[data-ui]');
        this.uiElements = {}
        this.$uiElements.forEach((el)=>{
            let name = el.getAttribute('id')
            let type =el.getAttribute('data-poi-type')
            this.uiElements[ name ] = {el, type}
        })

 
        //hide cursor when hover html clickable element
        this.$hoverUi = document.querySelectorAll('a, button, input, [role="button"], iframe')
        this.$hoverUi.forEach((el, i)=>{
            el.removeEventListener(support.pointerenter, this.onUIHover);
            el.removeEventListener(support.pointerleave, this.onUILeave);
            el.addEventListener(support.pointerenter, this.onUIHover);
            el.addEventListener(support.pointerleave, this.onUILeave);
        });

        this.$modaleSlideshow = document.querySelector('[data-modale-slideshow]')
        this.$modaleYoutube   = document.querySelector('[data-modale-youtube]')
        this.$modaleIframe    = document.querySelector('[data-modale-iframe]')

        // get template for slideshow slides
        this.$modaleSlideshowContent = document.querySelector('[data-modale-slideshow-content]');
        this.modaleSlideshowSlide = this.$modaleSlideshowContent.innerHTML;

        this.$modaleSlideshowContent.innerHTML = '';
        this.$modaleClose = document.querySelectorAll('[data-modale-close]')
        this.$modaleClose.forEach((el)=>{
            el.removeEventListener('click', this.onModalClose);
            el.addEventListener('click', this.onModalClose);
        });
        
        this.$spaLinks = document.querySelectorAll('[data-modale-link]')
        this.$spaLinks.forEach((el)=>{
            el.addEventListener('click', this.onModaleButtonDown);
        })

        this.$jsLinks = document.querySelectorAll('a');
        this.$jsLinks.forEach((el)=>{
            el.removeEventListener('click', this.onJsLinkDown);
            el.addEventListener('click', this.onJsLinkDown);
        });

        this.$innerTooltips      = document.querySelectorAll('[data-inner-tooltip]');
        this.$leaveSubRoomButton = document.querySelectorAll('[data-leave-sub-room]');
        this.$entersubRoomButton = document.querySelectorAll('[data-enter-sub-room]');
        this.$innerTooltips.forEach(_el => _el.style.display = 'none');
        this.$entersubRoomButton.forEach((el)=>{
            el.addEventListener('click', (e)=>{
                this.$poi.forEach(_el => _el.style.display = 'none');
                this.$leaveSubRoomButton.forEach(_el => _el.style.display = 'block');
                this.$innerTooltips.forEach(_el => _el.style.display = 'block');
                e.stopPropagation()
                e.preventDefault()
                console.log('__INNER_TOOLTIPS__', this.$leaveSubRoomButton);
                this.glSceneBridge.enterInnerRoom();
            });
        });
        this.$leaveSubRoomButton.forEach((el)=>{
            el.style.display = 'none';
            el.addEventListener('click', (e)=>{
                this.$poi.forEach(_el => _el.style.display = 'block');
                this.$leaveSubRoomButton.forEach(_el => _el.style.display = 'none');
                this.$innerTooltips.forEach(_el => _el.style.display = 'none');
                e.stopPropagation()
                e.preventDefault()
                this.glSceneBridge.leaveInnerRoom();
            });
        });
 

        document.removeEventListener('room-button-clicked', this.onGPTRoomBtnDown);        
        document.addEventListener('room-button-clicked', this.onGPTRoomBtnDown);

        this.selectedPoiIndex = -1;
        this.$poi = document.querySelectorAll('[data-poi]')
        this.$poi.forEach((el,i)=>{
            el.addEventListener('click', ()=>{ 
                this.selectedPoiIndex =  this.selectedPoiIndex == i ? -1 : i
                this.updatePoi()
            })
        });
        
        //mobile move controls
        this.$btnMoveUp = document.querySelector('[data-move-up]')
        this.$btnMoveDown = document.querySelector('[data-move-down]')
        this.$btnMoveUp && this.$btnMoveUp.addEventListener(support.pointerdown, (e)=>{ e.preventDefault();this._moveForward=true; })
        this.$btnMoveUp && this.$btnMoveUp.addEventListener(support.pointerup, (e)=>{  e.preventDefault();this._moveForward=false; })
        this.$btnMoveDown && this.$btnMoveDown.addEventListener(support.pointerdown, (e)=>{  e.preventDefault();this._moveBackward=true; })
        this.$btnMoveDown && this.$btnMoveDown.addEventListener(support.pointerup, (e)=>{ e.preventDefault();this._moveBackward=false; })
   
        this.isMenuOpened = false;
        this.$menuToggle = document.querySelector('[data-menu-toggle]')
        this.$menuToggle.removeEventListener('click', this.toggleMenu);
        this.$menuToggle.addEventListener('click', this.toggleMenu);
        // this.$menuItems = document.querySelectorAll('[data-menu-item]')
        // this.menuItems = {}
        // this.$menuItems.forEach((el)=>{
        //     let id = el.getAttribute('id')
        //     this.menuItems[ id ] = el
        // });

        const sceneJsonUrl = this.$pageContainer.getAttribute('data-scene-json');
        
        this.resize();

        // setTimeout(()=>{
            document.body.classList.add('is-ready');
        // }, 1000);

        await this.glSceneBridge.loadProject(sceneJsonUrl);

        this.glSceneBridge.resize();
        requestAnimationFrame(()=>{
            this.glSceneBridge?.resize();
        });
        
        setTimeout(()=>{

            document.body.classList.add('is-loaded');
            
            const $introScreen = this.querySelector('[data-intro]');
            if ($introScreen) {
                $introScreen.classList?.add('in-view');
            }

            let p =  {e:0};
            tween(p, {
                to: {e: 1},
                duration: 5,
                easing: [0.325, 0.060, 0.305, 1.000],
                step: (e) => {
                    this.glSceneBridge?.setIntroZoomProgress(p.e);
                },
                onComplete: ()=>{
                }
            })
 
            if (this.isIntroPage && this.useScroll) {
                this.$fakeScrollHeight.style.height = (window.innerHeight * this.numScrollVH) + 'px';
                this.glSceneBridge.setCameraProgress(0);
                requestAnimationFrame(()=>{
                    this.glSceneBridge?.resize();
                });
            }

            requestAnimationFrame(()=>{
                this.glSceneBridge?.resize();
            });
            
        }, 100);

        this.isLoaded = true;
        this.isLoading = false;
        
        numAvaerageFrames = 0;
        averageFPS        = 0;
        lastDate          = Date.now();
        hasForcedSDOnce   = false;
        hasAverageFPS     = false;

        this.$startButton = document.querySelector('[data-start-button]');
        if (this.$startButton) {
            this.$startButton.removeEventListener('click', this.onStartButtonDown);
            this.$startButton.addEventListener('click', this.onStartButtonDown);
            this.$startButton.style.setProperty('--maxWidth', this.$startButton.clientWidth + 'px');
        }

        this.resize();

    }

    onModaleButtonDown(e) {
        e.stopPropagation();
        e.preventDefault();
        const el = e.currentTarget;
        let type      = el.getAttribute('data-type')
        let slides    = el.getAttribute('data-slides')
        let youtubeId = el.getAttribute('data-youtube-id')
        let audio     = el.getAttribute('data-audio')
        let title     = el.getAttribute('data-title')
        let text      = el.getAttribute('data-text')
        this.openModale(title, text, type, slides, youtubeId, audio )
    }
    onStartButtonDown() {
        document.body.classList.add('hide-intro');
        if (this.useScroll) {
            this.$fakeScrollHeight.style.height = (window.innerHeight * this.numScrollVH) + 'px';
            // requestAnimationFrame(()=>{
            //     this.glSceneBridge?.resize();
            // });
            console.log('WINDOW_HEIGHT',window.innerHeight);
        }
        document.body.classList.add('is-scene-ready');
        // auto show the audio player except for mobile
        if (window.innerWidth > 600) {
            this.autoAudiotimer = setTimeout(()=>{
                this.isAudioOpened = true;
                document.body.classList['add']('is-audio-opened')
                this.autoAudiotimer = setTimeout(()=>{
                    this.isAudioOpened = false;
                    document.body.classList['remove']('is-audio-opened')
                }, 5000);
            }, 2000);
        }
    }

    onUIHover() {
        document.body.classList.add('is-hover-button');
    }

    onUILeave() {
        document.body.classList.remove('is-hover-button');
    }

    onModalClose() {
        this.closeModale();
    }

    onPlayBtnDown(e){ 
        this.playingaudio = !this.playingaudio
        this.$audioTag[this.playingaudio?'play':'pause']()
        this.$audioPlay.querySelector('[data-label]').innerHTML = this.playingaudio ? 'Pause Audio' : 'Play Audio' 
        this.$audioPlayIcon.style.display =  this.playingaudio ?  'none' : 'inline-block'
        this.$audioPauseIcon.style.display = !this.playingaudio ? 'none' : 'inline-block' 
    }

    onGPTButtonDown(e) {
        this.isGPTOpened = !this.isGPTOpened
        document.body.classList[this.isGPTOpened?'add':'remove']('is-gpt-opened');
        document.querySelector('#chatbot-widget .fui-Button.chatButton')?.click();
    }

    onAudioDown(e) {
        clearTimeout(this.autoAudiotimer)
        this.isAudioOpened = !this.isAudioOpened
        document.body.classList[this.isAudioOpened?'add':'remove']('is-audio-opened');
    }

    onPopState(e) {
        const url =
            e.state?.url ||
            this.normalizeInternalUrl(
                window.location.pathname + window.location.search + window.location.hash
            );
        console.log('POPSTATE_GOTOPAGE', url);
        this.goToPage(url, { pushState: false });
    }

    normalizeInternalUrl(href) {
        const targetUrl = new URL(href, document.baseURI);
        return (
            targetUrl.pathname.replace(/\/$/, '') + '/' +
            targetUrl.search +
            targetUrl.hash
        );
    }

    goToPage(url, { pushState = true } = {}) {

        this.isLoading = true;
        
        clearTimeout(this.autoAudiotimer);

        // Show main overlay
        document.body.classList.add('is-transition');
        
        setTimeout(()=>{
            
            window.location.href = url;
            return;

            document.body.classList.remove(
                'has-started','has-played-intro','is-audio-opened',
                'is-hover-button','is-intro', 'hide-intro','is-scene-ready',
                'is-menu-opened','is-loaded', 'is-ready'
            );
            

            this.hasStarted = false;
            this.cameraVelocity = 0;
            this.cameraVelocityBack = 0
            this.cameraVelocityLeft = 0
            this.cameraVelocityRight = 0
            this.cameraRotationY = 0
            window.scrollTo(0,0)
            this.scrollProgress = 0;
            this.easedScrollProgress = 0;

            this.glSceneBridge.setCameraProgress(0);

            if (window.innerWidth > 768) {
                // Force MD mode as the FPS can be different per scene
                this.setProfile('Desktop_Medium');
                hasForcedSDOnce = false;
                hasForcedHDOnce = false;
                lastDate;
                hasAverageFPS = false;
                averageFPS = 0;
                numAvaerageFrames = 100000;
            }
            
            if (pushState) {
                window.history.pushState({ url }, '', url);
            }

            this.xmlhttp = new XMLHttpRequest();
            this.xmlhttp.onreadystatechange = ()=>{
                if(this.xmlhttp.readyState === 4){
                    let resp = this.xmlhttp.responseText;
          
                    // parse into a separate HTML document with no custom element registry
                    const scratch = document.implementation.createHTMLDocument('');
                    scratch.body.innerHTML = resp;

                    // replace main page container with all the POI and scene infos
                    const newPageContainer = scratch.body.querySelector('[data-page-container]');
                    if (newPageContainer) {
                        const newNode = document.importNode(newPageContainer, true);
                        this.$pageContainer.parentNode.insertBefore(newNode, this.$pageContainer);
                        this.$pageContainer.parentNode.removeChild(this.$pageContainer);
                        this.$pageContainer = newNode;
                    }

                    // replace Bottom right nav with page specific content
                    const newBottomRightNav = scratch.body.querySelector('[bottom-right-nav]');
                    if (newBottomRightNav) {
                        const newNode = document.importNode(newBottomRightNav, true);
                        this.$bottomRightNav.parentNode.insertBefore(newNode, this.$bottomRightNav);
                        this.$bottomRightNav.parentNode.removeChild(this.$bottomRightNav);
                        this.$bottomRightNav = newNode;
                    }

                    this.initPage();

                }
            };

            this.xmlhttp.open('GET', url, true);
            this.xmlhttp.send();

        }, 1300);
    
    }

    onJsLinkDown(e) {
        const href = e.currentTarget.getAttribute('href');
        if (!href) return true;
        const targetUrl = new URL(href, document.baseURI);
        if (targetUrl.origin !== window.location.origin) {
            return true;
        }
        e.stopPropagation();
        e.preventDefault();
        const url = this.normalizeInternalUrl(href);
        console.log('JS_LINK_DOWN_GOTOPAGE');
        this.goToPage(url, { pushState: true });
        return false;
    }

    onGPTRoomBtnDown(e) {
        const url = this.normalizeInternalUrl( e.detail + '/');
        console.log('onGPTRoomBtnDown', e.detail, url);
        console.log('GPT_ROOM_BTN_GOTOPAGE');
        this.goToPage(url, { pushState: true });
    }

    updatePoi() {
        this.$poi.forEach((el,i)=>{
            if (i == this.selectedPoiIndex) {
                el.classList.add('is-active');
                el.setAttribute('aria-label', 'Close tooltip');
            }
            else {
                el.classList.remove('is-active');
                el.setAttribute('aria-label', 'Open tooltip');
            }
        });
    }
 

    onKeyDown(e) {
        switch( e.which ) {
            case 38: // up
              this._moveForward = true;
              e.preventDefault()
              break;
            case 37: // left
              this._moveLeft = true;
              break;
            case 40: // down
              this._moveBackward = true;
              e.preventDefault()
              break;
            case 39: // right
              this._moveRight = true;
              break;
        }
    }
    onKeyUp(e) {
        switch( e.which ) {
            case 38: // up
              this._moveForward = false;
              e.preventDefault()
              break;
            case 37: // left
              this._moveLeft = false;
              break;
            case 40: // down
              this._moveBackward = false;
              e.preventDefault()
              break;
            case 39: // right
              this._moveRight = false;
              break;
        }
    }


    getProfile() {
        return this.glSceneBridge.getProfile();
    }
    setProfile(profile) {
        // console.log('__SET_PROFILE__', '['+profile+']', 'Desktop_Medium');

        this.glSceneBridge.setProfile(profile);
        this.$modeButtons?.forEach((el)=>{
            if (el.getAttribute('data-mode') === profile){
                el.classList.add('is-active');
            }
            else {
                el.classList.remove('is-active');
            }
        });
    }
 
    update() {

        requestAnimationFrame(()=>{
            this.update();
        });

        //Forward/Backward camera movment
        //note: we chnage the scrollbar position to avoid conflcit between scroll and keyboard
        if (this._moveForward) { this.cameraVelocity += 0.0002 * 0.33 }
        else { this.cameraVelocity -= 0.0004 }

        if (this._moveBackward) { this.cameraVelocityBack += 0.0002 * 0.33 }
        else { this.cameraVelocityBack -= 0.0004 }

        this.cameraVelocity     = Math.max(0, Math.min(0.05, this.cameraVelocity));
        this.cameraVelocityBack = Math.max(0, Math.min(0.05, this.cameraVelocityBack));

        let destScrollTop = this._scrollTop;
        destScrollTop += this.cameraVelocity * (window.innerHeight * (this.numScrollVH-1));
        destScrollTop -= this.cameraVelocityBack * (window.innerHeight * (this.numScrollVH-1));
        if ( Math.abs(destScrollTop - this._scrollTop) > 0) {
            window.scrollTo( 0, destScrollTop );
        }
        
        //left/right camera rotation
        if (this._moveLeft) { this.cameraVelocityLeft += 0.003  }
        else { this.cameraVelocityLeft -= 0.003 }
        if (this._moveRight) { this.cameraVelocityRight += 0.003  }
        else { this.cameraVelocityRight -= 0.003 }
        this.cameraVelocityLeft = Math.max(0, Math.min(0.05, this.cameraVelocityLeft))
        this.cameraVelocityRight = Math.max(0, Math.min(0.05, this.cameraVelocityRight))

        // this.scrollProgress = this._scrollTop / (window.innerHeight * (this.numScrollVH-1));
        // if (this.scrollProgress != void 0 && this.scrollProgress != null && !isNaN(this.scrollProgress)) { 
        //     this.easedScrollProgress += (this.scrollProgress - this.easedScrollProgress) * 0.1;
        //     this.glSceneBridge.setCameraProgress(this.easedScrollProgress);
        // }
        // this.glSceneBridge.incrementCameraRotationY(this.cameraVelocityLeft + this.cameraVelocityRight * -1);

        // this.scrollProgress = this._scrollTop / (window.innerHeight * (this.numScrollVH-1));
        // const isScrolling = Math.abs(this.scrollProgress - this.easedScrollProgress) > 0.0001;
        // if (this.scrollProgress != void 0 && this.scrollProgress != null && !isNaN(this.scrollProgress)) { 
        //     this.easedScrollProgress += (this.scrollProgress - this.easedScrollProgress) * 0.1;
        //     this.glSceneBridge.setCameraProgress(this.easedScrollProgress);
        // }
        // if (isScrolling) {
        //     this.cameraVelocityLeft = 0;
        //     this.cameraVelocityRight = 0;
        // }
        // else {
        //     this.glSceneBridge.incrementCameraRotationY(this.cameraVelocityLeft + this.cameraVelocityRight * -1);
        // }



        this.scrollProgress = this._scrollTop / (window.innerHeight * (this.numScrollVH-1));
const isScrolling = Math.abs(this.scrollProgress - this._prevScrollProgress) > 0.0001;
this._prevScrollProgress = this.scrollProgress;

if (this.scrollProgress != void 0 && this.scrollProgress != null && !isNaN(this.scrollProgress)) { 
    this.easedScrollProgress += (this.scrollProgress - this.easedScrollProgress) * 0.1;
    this.glSceneBridge.setCameraProgress(this.easedScrollProgress);
}
if (isScrolling) {
    this.cameraVelocityLeft = 0;
    this.cameraVelocityRight = 0;
    this.glSceneBridge.resetCameraPathRotation();
}
else {
    this.glSceneBridge.incrementCameraRotationY(this.cameraVelocityLeft + this.cameraVelocityRight * -1);
}



    
        if (this.isIntroPage) {
            if ( this.glSceneBridge.getCameraProgress() > 0.2 ) {
                if (!this.hasStarted) {
                    document.body.classList.add('has-started')
                    document.body.classList.add('has-played-intro')
                    this.glSceneBridge.setHomeDrag(true);
                    this.hasStarted = true;
                    console.log('setHomeDrag')
                }
            }
            else {
                // if (this.hasStarted) {
                //     document.body.classList.remove('has-started')
                //     document.body.classList.add('has-played-intro')
                //     this.glSceneBridge.setHomeDrag(false);
                //     this.hasStarted = false;
                // }
            }
        }

        if ( (!this.isModaleOpened || (this.isModaleOpened && this.modaleType == 'mesh')) ) {
            this.glSceneBridge.update();
        }

        if (this.isMenuOpened  && settings.profile > 0) {
        }
        else if (this.isModaleOpened) {
        }
        else {
            let uiPos = this.glSceneBridge.getUIPositions();
            for (let k in this.uiElements) {
                if (uiPos[k]) {
                    let opacity = 1;
                    let scale = 1;
                    if (!this.isOldEngine) {
                        const maxDistance = uiPos[k][3] > -1 ? uiPos[k][3] : 2000;
                        this.uiElements[k].el.style.opacity = uiPos[k][2] > maxDistance ? 0 : 1;// (1 - Math.min(1, Math.max(0, (uiPos[k][2]-500) / 1500 )));
                        this.uiElements[k].el.style.transition = 'none';
                        this.uiElements[k].el.style.transform = `translate(${uiPos[k][0]}px,${uiPos[k][1]}px) translateZ(0)`;
                    }
                    else {
                        if (this.uiElements[k].type=='title') {
                            scale = 0.5 + Math.max(0,  1 - 1 * (uiPos[k][2] / 500) )
                            opacity = uiPos[k][2] > 300 ? (1 - Math.min(1, Math.max(0, (uiPos[k][2]-300) / 300))) : 1
                            this.uiElements[k].el.style.opacity = opacity;
                            this.uiElements[k].el.style.transform = `translate(${uiPos[k][0]}px,${uiPos[k][1]}px) scale(${scale}) translateZ(0)`;
                        }
                        else {
                            this.uiElements[k].el.style.transform = `translate(${Math.floor(uiPos[k][0]*100)/100}px,${Math.floor(uiPos[k][1]*100)/100}px) translateZ(0)`
                        }
                    }
                }
                else {
                    this.uiElements[k].el.style.transform = `translate(100vw,100vh) translateZ(0)`
                }
            }
        }
        
        if (this.cursor) {
            this.smoothedCursor.x += ( this.cursor.x - this.smoothedCursor.x ) * 0.1;
            this.smoothedCursor.y += ( (this.cursor.y) - this.smoothedCursor.y ) * 0.1;
            this.cursors.forEach((cursor)=>{
                cursor.layers.forEach((layer, i)=>{
                    let targetX = i == 0 ? this.smoothedCursor.x : cursor.layers[i-1].x
                    let targetY = (i == 0 ? (this.smoothedCursor.y) : cursor.layers[i-1].y )
                    layer.x += ( targetX - layer.x ) * (i==0 ? cursor.ratio : 0.7)
                    layer.y += ( targetY - layer.y ) * (i==0 ? cursor.ratio : 0.7)
                    layer.el.style.transform = `translate(${Math.floor(layer.x*100)/100}px, ${Math.floor(layer.y*100)/100}px) translateZ(0)`;
                })
            });
        }
        
        if (this.isLoaded && !settings.updateShadows && !settings.isUpdatingIBL) {
            if (!lastDate) {
                lastDate = Date.now()
            }
            else {
                //Avearge FPs accross 150 frame to see if we upgrade quality or need to downgrade
                if (numAvaerageFrames < 150) {
                    if (numAvaerageFrames <= 2) {//making sure first frame dont generate falsy results
                        lastDate = Date.now()
                    }
                    let diff =Date.now() - lastDate
                    if (diff > 150) {
                        diff = 150;///making sure first frame drop dont generate falsy results
                    }
                    averageFPS += ((Date.now() - lastDate) );
                    numAvaerageFrames++;
                    lastDate = Date.now()
                }

                

                else {

                    // console.log('PROFILE', this.getProfile());

                    // O:forward | 1:SD | 2:MD | 3:HD
                    if ( this.getProfile() === 'Desktop_High' && averageFPS / numAvaerageFrames > 60) {//50==20fps
                        this.setProfile('Desktop_Medium');
                        averageFPS = 0;
                        numAvaerageFrames = 0;
                        lastDate = Date.now();
                    }
                    else if (!hasForcedSDOnce && this.getProfile() === 'Desktop_Medium' && averageFPS / numAvaerageFrames > 60) {//50==20fps
                        hasForcedSDOnce = true;// use flag to prevent looping on SD mode if fps is low
                        this.setProfile('Desktop_Low');
                        averageFPS = 0;
                        numAvaerageFrames = 0;
                        lastDate = Date.now();
                    }
                    else if (!hasForcedHDOnce && this.getProfile() === 'Desktop_Medium' && (averageFPS / numAvaerageFrames) < 19) {
                        hasForcedHDOnce = true;
                        this.setProfile('Desktop_High');
                        averageFPS = 0;
                        numAvaerageFrames = 0;
                        lastDate = Date.now();
                    }
                    else {
                        if (hasAverageFPS) {
                            hasAverageFPS = true
                        }
                    }
                }
            }
        }        

    }

}

customElements.define('web-application', WebApplication);